// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3T3_r","left":"styles_left__1M0op","navigationLink":"styles_navigationLink__vRvWu"};